import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type BaseBadgeProps = {
  className?: string;
} & PropsWithChildren;

export const BaseBadge: FC<BaseBadgeProps> = ({ className, children }) => {
  return (
    <p className={twMerge('h-fit w-fit rounded-[0.313rem] bg-gray-200 px-2.5 py-0.5 text-xs font-medium text-grey-600 truncate', className)}>{children}</p>
  );
};
